import React from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, Label } from 'reactstrap';
import { AvForm, AvGroup, AvInput, AvField } from 'availity-reactstrap-validation';
// tslint:disable-next-line:no-unused-variable
import { Translate, translate, ICrudGetAction, ICrudGetAllAction, ICrudPutAction } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IRootState } from 'app/shared/reducers';

import { getEntity, updateEntity, createEntity, reset } from './tenant.reducer';
import { ITenant } from 'app/shared/model/tenant.model';
// tslint:disable-next-line:no-unused-variable
import { convertDateTimeFromServer, convertDateTimeToServer } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';

export interface ITenantUpdateProps extends StateProps, DispatchProps, RouteComponentProps<{ id: string }> {}

export interface ITenantUpdateState {
  isNew: boolean;
}

export class TenantUpdate extends React.Component<ITenantUpdateProps, ITenantUpdateState> {
  constructor(props) {
    super(props);
    this.state = {
      isNew: !this.props.match.params || !this.props.match.params.id
    };
  }

  componentWillUpdate(nextProps, nextState) {
    if (nextProps.updateSuccess !== this.props.updateSuccess && nextProps.updateSuccess) {
      this.handleClose();
    }
  }

  componentDidMount() {
    if (this.state.isNew) {
      this.props.reset();
    } else {
      this.props.getEntity(this.props.match.params.id);
    }
  }

  saveEntity = (event, errors, values) => {
    values.createdDate = convertDateTimeToServer(values.createdDate);
    values.lastModifiedDate = convertDateTimeToServer(values.lastModifiedDate);

    if (errors.length === 0) {
      const { tenantEntity } = this.props;
      const entity = {
        ...tenantEntity,
        ...values
      };

      if (this.state.isNew) {
        this.props.createEntity(entity);
      } else {
        this.props.updateEntity(entity);
      }
    }
  };

  handleClose = () => {
    this.props.history.push('/entity/tenant');
  };

  render() {
    const { tenantEntity, loading, updating } = this.props;
    const { isNew } = this.state;

    return (
      <div>
        <Row className="justify-content-center">
          <Col md="8">
            <h2 id="dealorGatewayApp.tenant.home.createOrEditLabel">
              <Translate contentKey="dealorGatewayApp.tenant.home.createOrEditLabel">Create or edit a Tenant</Translate>
            </h2>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col md="8">
            {loading ? (
              <p>Loading...</p>
            ) : (
              <AvForm model={isNew ? {} : tenantEntity} onSubmit={this.saveEntity}>
                {!isNew ? (
                  <AvGroup>
                    <Label for="id">
                      <Translate contentKey="global.field.id">ID</Translate>
                    </Label>
                    <AvInput id="tenant-id" type="text" className="form-control" name="id" required readOnly />
                  </AvGroup>
                ) : null}
                <AvGroup>
                  <Label id="nameLabel" for="name">
                    <Translate contentKey="dealorGatewayApp.tenant.name">Name</Translate>
                  </Label>
                  <AvField
                    id="tenant-name"
                    type="text"
                    name="name"
                    validate={{
                      required: { value: true, errorMessage: translate('entity.validation.required') },
                      maxLength: { value: 256, errorMessage: translate('entity.validation.maxlength', { max: 256 }) }
                    }}
                  />
                </AvGroup>
                <AvGroup>
                  <Label id="zoneIdLabel" for="zoneId">
                    <Translate contentKey="dealorGatewayApp.tenant.zoneId">ZoneId</Translate>
                  </Label>
                  <AvField
                    id="tenant-zoneId"
                    type="select"
                    name="zoneId"
                    validate={{
                      required: { value: true, errorMessage: translate('entity.validation.required') }
                    }}
                  >
                    <option value="Israel">Israel (UTC+03:00)</option>
                    <option value="Etc/GMT+12">Etc/GMT+12 (UTC-12:00)</option>
                    <option value="Pacific/Pago_Pago">Pacific/Pago_Pago (UTC-11:00)</option>
                    <option value="Pacific/Samoa">Pacific/Samoa (UTC-11:00)</option>
                    <option value="Pacific/Niue">Pacific/Niue (UTC-11:00)</option>
                    <option value="US/Samoa">US/Samoa (UTC-11:00)</option>
                    <option value="Etc/GMT+11">Etc/GMT+11 (UTC-11:00)</option>
                    <option value="Pacific/Midway">Pacific/Midway (UTC-11:00)</option>
                    <option value="Pacific/Honolulu">Pacific/Honolulu (UTC-10:00)</option>
                    <option value="Pacific/Rarotonga">Pacific/Rarotonga (UTC-10:00)</option>
                    <option value="Pacific/Tahiti">Pacific/Tahiti (UTC-10:00)</option>
                    <option value="Pacific/Johnston">Pacific/Johnston (UTC-10:00)</option>
                    <option value="US/Hawaii">US/Hawaii (UTC-10:00)</option>
                    <option value="SystemV/HST10">SystemV/HST10 (UTC-10:00)</option>
                    <option value="Etc/GMT+10">Etc/GMT+10 (UTC-10:00)</option>
                    <option value="Pacific/Marquesas">Pacific/Marquesas (UTC-09:30)</option>
                    <option value="Etc/GMT+9">Etc/GMT+9 (UTC-09:00)</option>
                    <option value="Pacific/Gambier">Pacific/Gambier (UTC-09:00)</option>
                    <option value="America/Atka">America/Atka (UTC-09:00)</option>
                    <option value="SystemV/YST9">SystemV/YST9 (UTC-09:00)</option>
                    <option value="America/Adak">America/Adak (UTC-09:00)</option>
                    <option value="US/Aleutian">US/Aleutian (UTC-09:00)</option>
                    <option value="Etc/GMT+8">Etc/GMT+8 (UTC-08:00)</option>
                    <option value="US/Alaska">US/Alaska (UTC-08:00)</option>
                    <option value="America/Juneau">America/Juneau (UTC-08:00)</option>
                    <option value="America/Metlakatla">America/Metlakatla (UTC-08:00)</option>
                    <option value="America/Yakutat">America/Yakutat (UTC-08:00)</option>
                    <option value="Pacific/Pitcairn">Pacific/Pitcairn (UTC-08:00)</option>
                    <option value="America/Sitka">America/Sitka (UTC-08:00)</option>
                    <option value="America/Anchorage">America/Anchorage (UTC-08:00)</option>
                    <option value="SystemV/PST8">SystemV/PST8 (UTC-08:00)</option>
                    <option value="America/Nome">America/Nome (UTC-08:00)</option>
                    <option value="SystemV/YST9YDT">SystemV/YST9YDT (UTC-08:00)</option>
                    <option value="Canada/Yukon">Canada/Yukon (UTC-07:00)</option>
                    <option value="US/Pacific-New">US/Pacific-New (UTC-07:00)</option>
                    <option value="Etc/GMT+7">Etc/GMT+7 (UTC-07:00)</option>
                    <option value="US/Arizona">US/Arizona (UTC-07:00)</option>
                    <option value="America/Dawson_Creek">America/Dawson_Creek (UTC-07:00)</option>
                    <option value="Canada/Pacific">Canada/Pacific (UTC-07:00)</option>
                    <option value="PST8PDT">PST8PDT (UTC-07:00)</option>
                    <option value="SystemV/MST7">SystemV/MST7 (UTC-07:00)</option>
                    <option value="America/Dawson">America/Dawson (UTC-07:00)</option>
                    <option value="Mexico/BajaNorte">Mexico/BajaNorte (UTC-07:00)</option>
                    <option value="America/Tijuana">America/Tijuana (UTC-07:00)</option>
                    <option value="America/Creston">America/Creston (UTC-07:00)</option>
                    <option value="America/Hermosillo">America/Hermosillo (UTC-07:00)</option>
                    <option value="America/Santa_Isabel">America/Santa_Isabel (UTC-07:00)</option>
                    <option value="America/Vancouver">America/Vancouver (UTC-07:00)</option>
                    <option value="America/Ensenada">America/Ensenada (UTC-07:00)</option>
                    <option value="America/Phoenix">America/Phoenix (UTC-07:00)</option>
                    <option value="America/Whitehorse">America/Whitehorse (UTC-07:00)</option>
                    <option value="America/Fort_Nelson">America/Fort_Nelson (UTC-07:00)</option>
                    <option value="SystemV/PST8PDT">SystemV/PST8PDT (UTC-07:00)</option>
                    <option value="America/Los_Angeles">America/Los_Angeles (UTC-07:00)</option>
                    <option value="US/Pacific">US/Pacific (UTC-07:00)</option>
                    <option value="America/El_Salvador">America/El_Salvador (UTC-06:00)</option>
                    <option value="America/Guatemala">America/Guatemala (UTC-06:00)</option>
                    <option value="America/Belize">America/Belize (UTC-06:00)</option>
                    <option value="America/Managua">America/Managua (UTC-06:00)</option>
                    <option value="America/Tegucigalpa">America/Tegucigalpa (UTC-06:00)</option>
                    <option value="Etc/GMT+6">Etc/GMT+6 (UTC-06:00)</option>
                    <option value="Pacific/Easter">Pacific/Easter (UTC-06:00)</option>
                    <option value="Mexico/BajaSur">Mexico/BajaSur (UTC-06:00)</option>
                    <option value="America/Regina">America/Regina (UTC-06:00)</option>
                    <option value="America/Denver">America/Denver (UTC-06:00)</option>
                    <option value="Pacific/Galapagos">Pacific/Galapagos (UTC-06:00)</option>
                    <option value="America/Yellowknife">America/Yellowknife (UTC-06:00)</option>
                    <option value="America/Swift_Current">America/Swift_Current (UTC-06:00)</option>
                    <option value="America/Inuvik">America/Inuvik (UTC-06:00)</option>
                    <option value="America/Mazatlan">America/Mazatlan (UTC-06:00)</option>
                    <option value="America/Boise">America/Boise (UTC-06:00)</option>
                    <option value="America/Costa_Rica">America/Costa_Rica (UTC-06:00)</option>
                    <option value="MST7MDT">MST7MDT (UTC-06:00)</option>
                    <option value="SystemV/CST6">SystemV/CST6 (UTC-06:00)</option>
                    <option value="America/Chihuahua">America/Chihuahua (UTC-06:00)</option>
                    <option value="America/Ojinaga">America/Ojinaga (UTC-06:00)</option>
                    <option value="Chile/EasterIsland">Chile/EasterIsland (UTC-06:00)</option>
                    <option value="US/Mountain">US/Mountain (UTC-06:00)</option>
                    <option value="America/Edmonton">America/Edmonton (UTC-06:00)</option>
                    <option value="Canada/Mountain">Canada/Mountain (UTC-06:00)</option>
                    <option value="America/Cambridge_Bay">America/Cambridge_Bay (UTC-06:00)</option>
                    <option value="Navajo">Navajo (UTC-06:00)</option>
                    <option value="SystemV/MST7MDT">SystemV/MST7MDT (UTC-06:00)</option>
                    <option value="Canada/Saskatchewan">Canada/Saskatchewan (UTC-06:00)</option>
                    <option value="America/Shiprock">America/Shiprock (UTC-06:00)</option>
                    <option value="America/Panama">America/Panama (UTC-05:00)</option>
                    <option value="America/Chicago">America/Chicago (UTC-05:00)</option>
                    <option value="America/Eirunepe">America/Eirunepe (UTC-05:00)</option>
                    <option value="Etc/GMT+5">Etc/GMT+5 (UTC-05:00)</option>
                    <option value="Mexico/General">Mexico/General (UTC-05:00)</option>
                    <option value="America/Porto_Acre">America/Porto_Acre (UTC-05:00)</option>
                    <option value="America/Guayaquil">America/Guayaquil (UTC-05:00)</option>
                    <option value="America/Rankin_Inlet">America/Rankin_Inlet (UTC-05:00)</option>
                    <option value="US/Central">US/Central (UTC-05:00)</option>
                    <option value="America/Rainy_River">America/Rainy_River (UTC-05:00)</option>
                    <option value="America/Indiana/Knox">America/Indiana/Knox (UTC-05:00)</option>
                    <option value="America/North_Dakota/Beulah">America/North_Dakota/Beulah (UTC-05:00)</option>
                    <option value="America/Monterrey">America/Monterrey (UTC-05:00)</option>
                    <option value="America/Jamaica">America/Jamaica (UTC-05:00)</option>
                    <option value="America/Atikokan">America/Atikokan (UTC-05:00)</option>
                    <option value="America/Coral_Harbour">America/Coral_Harbour (UTC-05:00)</option>
                    <option value="America/North_Dakota/Center">America/North_Dakota/Center (UTC-05:00)</option>
                    <option value="America/Cayman">America/Cayman (UTC-05:00)</option>
                    <option value="America/Indiana/Tell_City">America/Indiana/Tell_City (UTC-05:00)</option>
                    <option value="America/Mexico_City">America/Mexico_City (UTC-05:00)</option>
                    <option value="America/Matamoros">America/Matamoros (UTC-05:00)</option>
                    <option value="CST6CDT">CST6CDT (UTC-05:00)</option>
                    <option value="America/Knox_IN">America/Knox_IN (UTC-05:00)</option>
                    <option value="America/Bogota">America/Bogota (UTC-05:00)</option>
                    <option value="America/Menominee">America/Menominee (UTC-05:00)</option>
                    <option value="America/Resolute">America/Resolute (UTC-05:00)</option>
                    <option value="SystemV/EST5">SystemV/EST5 (UTC-05:00)</option>
                    <option value="Canada/Central">Canada/Central (UTC-05:00)</option>
                    <option value="Brazil/Acre">Brazil/Acre (UTC-05:00)</option>
                    <option value="America/Cancun">America/Cancun (UTC-05:00)</option>
                    <option value="America/Lima">America/Lima (UTC-05:00)</option>
                    <option value="America/Bahia_Banderas">America/Bahia_Banderas (UTC-05:00)</option>
                    <option value="US/Indiana-Starke">US/Indiana-Starke (UTC-05:00)</option>
                    <option value="America/Rio_Branco">America/Rio_Branco (UTC-05:00)</option>
                    <option value="SystemV/CST6CDT">SystemV/CST6CDT (UTC-05:00)</option>
                    <option value="Jamaica">Jamaica (UTC-05:00)</option>
                    <option value="America/Merida">America/Merida (UTC-05:00)</option>
                    <option value="America/North_Dakota/New_Salem">America/North_Dakota/New_Salem (UTC-05:00)</option>
                    <option value="America/Winnipeg">America/Winnipeg (UTC-05:00)</option>
                    <option value="America/Cuiaba">America/Cuiaba (UTC-04:00)</option>
                    <option value="America/Marigot">America/Marigot (UTC-04:00)</option>
                    <option value="America/Indiana/Petersburg">America/Indiana/Petersburg (UTC-04:00)</option>
                    <option value="Chile/Continental">Chile/Continental (UTC-04:00)</option>
                    <option value="America/Grand_Turk">America/Grand_Turk (UTC-04:00)</option>
                    <option value="Cuba">Cuba (UTC-04:00)</option>
                    <option value="Etc/GMT+4">Etc/GMT+4 (UTC-04:00)</option>
                    <option value="America/Manaus">America/Manaus (UTC-04:00)</option>
                    <option value="America/Fort_Wayne">America/Fort_Wayne (UTC-04:00)</option>
                    <option value="America/St_Thomas">America/St_Thomas (UTC-04:00)</option>
                    <option value="America/Anguilla">America/Anguilla (UTC-04:00)</option>
                    <option value="America/Havana">America/Havana (UTC-04:00)</option>
                    <option value="US/Michigan">US/Michigan (UTC-04:00)</option>
                    <option value="America/Barbados">America/Barbados (UTC-04:00)</option>
                    <option value="America/Louisville">America/Louisville (UTC-04:00)</option>
                    <option value="America/Curacao">America/Curacao (UTC-04:00)</option>
                    <option value="America/Guyana">America/Guyana (UTC-04:00)</option>
                    <option value="America/Martinique">America/Martinique (UTC-04:00)</option>
                    <option value="America/Puerto_Rico">America/Puerto_Rico (UTC-04:00)</option>
                    <option value="America/Port_of_Spain">America/Port_of_Spain (UTC-04:00)</option>
                    <option value="SystemV/AST4">SystemV/AST4 (UTC-04:00)</option>
                    <option value="America/Indiana/Vevay">America/Indiana/Vevay (UTC-04:00)</option>
                    <option value="America/Indiana/Vincennes">America/Indiana/Vincennes (UTC-04:00)</option>
                    <option value="America/Kralendijk">America/Kralendijk (UTC-04:00)</option>
                    <option value="America/Antigua">America/Antigua (UTC-04:00)</option>
                    <option value="America/Indianapolis">America/Indianapolis (UTC-04:00)</option>
                    <option value="America/Iqaluit">America/Iqaluit (UTC-04:00)</option>
                    <option value="America/St_Vincent">America/St_Vincent (UTC-04:00)</option>
                    <option value="America/Kentucky/Louisville">America/Kentucky/Louisville (UTC-04:00)</option>
                    <option value="America/Dominica">America/Dominica (UTC-04:00)</option>
                    <option value="America/Asuncion">America/Asuncion (UTC-04:00)</option>
                    <option value="EST5EDT">EST5EDT (UTC-04:00)</option>
                    <option value="America/Nassau">America/Nassau (UTC-04:00)</option>
                    <option value="America/Kentucky/Monticello">America/Kentucky/Monticello (UTC-04:00)</option>
                    <option value="Brazil/West">Brazil/West (UTC-04:00)</option>
                    <option value="America/Aruba">America/Aruba (UTC-04:00)</option>
                    <option value="America/Indiana/Indianapolis">America/Indiana/Indianapolis (UTC-04:00)</option>
                    <option value="America/Santiago">America/Santiago (UTC-04:00)</option>
                    <option value="America/La_Paz">America/La_Paz (UTC-04:00)</option>
                    <option value="America/Thunder_Bay">America/Thunder_Bay (UTC-04:00)</option>
                    <option value="America/Indiana/Marengo">America/Indiana/Marengo (UTC-04:00)</option>
                    <option value="America/Blanc-Sablon">America/Blanc-Sablon (UTC-04:00)</option>
                    <option value="America/Santo_Domingo">America/Santo_Domingo (UTC-04:00)</option>
                    <option value="US/Eastern">US/Eastern (UTC-04:00)</option>
                    <option value="Canada/Eastern">Canada/Eastern (UTC-04:00)</option>
                    <option value="America/Port-au-Prince">America/Port-au-Prince (UTC-04:00)</option>
                    <option value="America/St_Barthelemy">America/St_Barthelemy (UTC-04:00)</option>
                    <option value="America/Nipigon">America/Nipigon (UTC-04:00)</option>
                    <option value="US/East-Indiana">US/East-Indiana (UTC-04:00)</option>
                    <option value="America/St_Lucia">America/St_Lucia (UTC-04:00)</option>
                    <option value="America/Montserrat">America/Montserrat (UTC-04:00)</option>
                    <option value="America/Lower_Princes">America/Lower_Princes (UTC-04:00)</option>
                    <option value="America/Detroit">America/Detroit (UTC-04:00)</option>
                    <option value="America/Tortola">America/Tortola (UTC-04:00)</option>
                    <option value="America/Porto_Velho">America/Porto_Velho (UTC-04:00)</option>
                    <option value="America/Campo_Grande">America/Campo_Grande (UTC-04:00)</option>
                    <option value="America/Virgin">America/Virgin (UTC-04:00)</option>
                    <option value="America/Pangnirtung">America/Pangnirtung (UTC-04:00)</option>
                    <option value="America/Montreal">America/Montreal (UTC-04:00)</option>
                    <option value="America/Indiana/Winamac">America/Indiana/Winamac (UTC-04:00)</option>
                    <option value="America/Boa_Vista">America/Boa_Vista (UTC-04:00)</option>
                    <option value="America/Grenada">America/Grenada (UTC-04:00)</option>
                    <option value="America/New_York">America/New_York (UTC-04:00)</option>
                    <option value="America/St_Kitts">America/St_Kitts (UTC-04:00)</option>
                    <option value="America/Caracas">America/Caracas (UTC-04:00)</option>
                    <option value="America/Guadeloupe">America/Guadeloupe (UTC-04:00)</option>
                    <option value="America/Toronto">America/Toronto (UTC-04:00)</option>
                    <option value="SystemV/EST5EDT">SystemV/EST5EDT (UTC-04:00)</option>
                    <option value="America/Argentina/Catamarca">America/Argentina/Catamarca (UTC-03:00)</option>
                    <option value="Canada/Atlantic">Canada/Atlantic (UTC-03:00)</option>
                    <option value="America/Argentina/Cordoba">America/Argentina/Cordoba (UTC-03:00)</option>
                    <option value="America/Araguaina">America/Araguaina (UTC-03:00)</option>
                    <option value="America/Argentina/Salta">America/Argentina/Salta (UTC-03:00)</option>
                    <option value="Etc/GMT+3">Etc/GMT+3 (UTC-03:00)</option>
                    <option value="America/Montevideo">America/Montevideo (UTC-03:00)</option>
                    <option value="Brazil/East">Brazil/East (UTC-03:00)</option>
                    <option value="America/Argentina/Mendoza">America/Argentina/Mendoza (UTC-03:00)</option>
                    <option value="America/Argentina/Rio_Gallegos">America/Argentina/Rio_Gallegos (UTC-03:00)</option>
                    <option value="America/Catamarca">America/Catamarca (UTC-03:00)</option>
                    <option value="America/Cordoba">America/Cordoba (UTC-03:00)</option>
                    <option value="America/Sao_Paulo">America/Sao_Paulo (UTC-03:00)</option>
                    <option value="America/Argentina/Jujuy">America/Argentina/Jujuy (UTC-03:00)</option>
                    <option value="America/Cayenne">America/Cayenne (UTC-03:00)</option>
                    <option value="America/Recife">America/Recife (UTC-03:00)</option>
                    <option value="America/Buenos_Aires">America/Buenos_Aires (UTC-03:00)</option>
                    <option value="America/Paramaribo">America/Paramaribo (UTC-03:00)</option>
                    <option value="America/Moncton">America/Moncton (UTC-03:00)</option>
                    <option value="America/Mendoza">America/Mendoza (UTC-03:00)</option>
                    <option value="America/Santarem">America/Santarem (UTC-03:00)</option>
                    <option value="Atlantic/Bermuda">Atlantic/Bermuda (UTC-03:00)</option>
                    <option value="America/Maceio">America/Maceio (UTC-03:00)</option>
                    <option value="Atlantic/Stanley">Atlantic/Stanley (UTC-03:00)</option>
                    <option value="America/Halifax">America/Halifax (UTC-03:00)</option>
                    <option value="Antarctica/Rothera">Antarctica/Rothera (UTC-03:00)</option>
                    <option value="America/Argentina/San_Luis">America/Argentina/San_Luis (UTC-03:00)</option>
                    <option value="America/Argentina/Ushuaia">America/Argentina/Ushuaia (UTC-03:00)</option>
                    <option value="Antarctica/Palmer">Antarctica/Palmer (UTC-03:00)</option>
                    <option value="America/Punta_Arenas">America/Punta_Arenas (UTC-03:00)</option>
                    <option value="America/Glace_Bay">America/Glace_Bay (UTC-03:00)</option>
                    <option value="America/Fortaleza">America/Fortaleza (UTC-03:00)</option>
                    <option value="America/Thule">America/Thule (UTC-03:00)</option>
                    <option value="America/Argentina/La_Rioja">America/Argentina/La_Rioja (UTC-03:00)</option>
                    <option value="America/Belem">America/Belem (UTC-03:00)</option>
                    <option value="America/Jujuy">America/Jujuy (UTC-03:00)</option>
                    <option value="America/Bahia">America/Bahia (UTC-03:00)</option>
                    <option value="America/Goose_Bay">America/Goose_Bay (UTC-03:00)</option>
                    <option value="America/Argentina/San_Juan">America/Argentina/San_Juan (UTC-03:00)</option>
                    <option value="America/Argentina/ComodRivadavia">America/Argentina/ComodRivadavia (UTC-03:00)</option>
                    <option value="America/Argentina/Tucuman">America/Argentina/Tucuman (UTC-03:00)</option>
                    <option value="America/Rosario">America/Rosario (UTC-03:00)</option>
                    <option value="SystemV/AST4ADT">SystemV/AST4ADT (UTC-03:00)</option>
                    <option value="America/Argentina/Buenos_Aires">America/Argentina/Buenos_Aires (UTC-03:00)</option>
                    <option value="America/St_Johns">America/St_Johns (UTC-02:30)</option>
                    <option value="Canada/Newfoundland">Canada/Newfoundland (UTC-02:30)</option>
                    <option value="America/Miquelon">America/Miquelon (UTC-02:00)</option>
                    <option value="Etc/GMT+2">Etc/GMT+2 (UTC-02:00)</option>
                    <option value="America/Godthab">America/Godthab (UTC-02:00)</option>
                    <option value="America/Noronha">America/Noronha (UTC-02:00)</option>
                    <option value="Brazil/DeNoronha">Brazil/DeNoronha (UTC-02:00)</option>
                    <option value="Atlantic/South_Georgia">Atlantic/South_Georgia (UTC-02:00)</option>
                    <option value="Etc/GMT+1">Etc/GMT+1 (UTC-01:00)</option>
                    <option value="Atlantic/Cape_Verde">Atlantic/Cape_Verde (UTC-01:00)</option>
                    <option value="Pacific/Kiritimati">Pacific/Kiritimati (UTC+14:00)</option>
                    <option value="Etc/GMT-14">Etc/GMT-14 (UTC+14:00)</option>
                    <option value="Pacific/Fakaofo">Pacific/Fakaofo (UTC+13:00)</option>
                    <option value="Pacific/Enderbury">Pacific/Enderbury (UTC+13:00)</option>
                    <option value="Pacific/Apia">Pacific/Apia (UTC+13:00)</option>
                    <option value="Pacific/Tongatapu">Pacific/Tongatapu (UTC+13:00)</option>
                    <option value="Etc/GMT-13">Etc/GMT-13 (UTC+13:00)</option>
                    <option value="NZ-CHAT">NZ-CHAT (UTC+12:45)</option>
                    <option value="Pacific/Chatham">Pacific/Chatham (UTC+12:45)</option>
                    <option value="Pacific/Kwajalein">Pacific/Kwajalein (UTC+12:00)</option>
                    <option value="Antarctica/McMurdo">Antarctica/McMurdo (UTC+12:00)</option>
                    <option value="Pacific/Wallis">Pacific/Wallis (UTC+12:00)</option>
                    <option value="Pacific/Fiji">Pacific/Fiji (UTC+12:00)</option>
                    <option value="Pacific/Funafuti">Pacific/Funafuti (UTC+12:00)</option>
                    <option value="Pacific/Nauru">Pacific/Nauru (UTC+12:00)</option>
                    <option value="Kwajalein">Kwajalein (UTC+12:00)</option>
                    <option value="NZ">NZ (UTC+12:00)</option>
                    <option value="Pacific/Wake">Pacific/Wake (UTC+12:00)</option>
                    <option value="Antarctica/South_Pole">Antarctica/South_Pole (UTC+12:00)</option>
                    <option value="Pacific/Tarawa">Pacific/Tarawa (UTC+12:00)</option>
                    <option value="Pacific/Auckland">Pacific/Auckland (UTC+12:00)</option>
                    <option value="Asia/Kamchatka">Asia/Kamchatka (UTC+12:00)</option>
                    <option value="Etc/GMT-12">Etc/GMT-12 (UTC+12:00)</option>
                    <option value="Asia/Anadyr">Asia/Anadyr (UTC+12:00)</option>
                    <option value="Pacific/Majuro">Pacific/Majuro (UTC+12:00)</option>
                    <option value="Pacific/Ponape">Pacific/Ponape (UTC+11:00)</option>
                    <option value="Pacific/Bougainville">Pacific/Bougainville (UTC+11:00)</option>
                    <option value="Antarctica/Macquarie">Antarctica/Macquarie (UTC+11:00)</option>
                    <option value="Pacific/Pohnpei">Pacific/Pohnpei (UTC+11:00)</option>
                    <option value="Pacific/Efate">Pacific/Efate (UTC+11:00)</option>
                    <option value="Pacific/Norfolk">Pacific/Norfolk (UTC+11:00)</option>
                    <option value="Asia/Magadan">Asia/Magadan (UTC+11:00)</option>
                    <option value="Pacific/Kosrae">Pacific/Kosrae (UTC+11:00)</option>
                    <option value="Asia/Sakhalin">Asia/Sakhalin (UTC+11:00)</option>
                    <option value="Pacific/Noumea">Pacific/Noumea (UTC+11:00)</option>
                    <option value="Etc/GMT-11">Etc/GMT-11 (UTC+11:00)</option>
                    <option value="Asia/Srednekolymsk">Asia/Srednekolymsk (UTC+11:00)</option>
                    <option value="Pacific/Guadalcanal">Pacific/Guadalcanal (UTC+11:00)</option>
                    <option value="Australia/Lord_Howe">Australia/Lord_Howe (UTC+10:30)</option>
                    <option value="Australia/LHI">Australia/LHI (UTC+10:30)</option>
                    <option value="Australia/Hobart">Australia/Hobart (UTC+10:00)</option>
                    <option value="Pacific/Yap">Pacific/Yap (UTC+10:00)</option>
                    <option value="Australia/Tasmania">Australia/Tasmania (UTC+10:00)</option>
                    <option value="Pacific/Port_Moresby">Pacific/Port_Moresby (UTC+10:00)</option>
                    <option value="Australia/ACT">Australia/ACT (UTC+10:00)</option>
                    <option value="Australia/Victoria">Australia/Victoria (UTC+10:00)</option>
                    <option value="Pacific/Chuuk">Pacific/Chuuk (UTC+10:00)</option>
                    <option value="Australia/Queensland">Australia/Queensland (UTC+10:00)</option>
                    <option value="Australia/Canberra">Australia/Canberra (UTC+10:00)</option>
                    <option value="Australia/Currie">Australia/Currie (UTC+10:00)</option>
                    <option value="Pacific/Guam">Pacific/Guam (UTC+10:00)</option>
                    <option value="Pacific/Truk">Pacific/Truk (UTC+10:00)</option>
                    <option value="Australia/NSW">Australia/NSW (UTC+10:00)</option>
                    <option value="Asia/Vladivostok">Asia/Vladivostok (UTC+10:00)</option>
                    <option value="Pacific/Saipan">Pacific/Saipan (UTC+10:00)</option>
                    <option value="Antarctica/DumontDUrville">Antarctica/DumontDUrville (UTC+10:00)</option>
                    <option value="Australia/Sydney">Australia/Sydney (UTC+10:00)</option>
                    <option value="Australia/Brisbane">Australia/Brisbane (UTC+10:00)</option>
                    <option value="Etc/GMT-10">Etc/GMT-10 (UTC+10:00)</option>
                    <option value="Asia/Ust-Nera">Asia/Ust-Nera (UTC+10:00)</option>
                    <option value="Australia/Melbourne">Australia/Melbourne (UTC+10:00)</option>
                    <option value="Australia/Lindeman">Australia/Lindeman (UTC+10:00)</option>
                    <option value="Australia/North">Australia/North (UTC+09:30)</option>
                    <option value="Australia/Yancowinna">Australia/Yancowinna (UTC+09:30)</option>
                    <option value="Australia/Adelaide">Australia/Adelaide (UTC+09:30)</option>
                    <option value="Australia/Broken_Hill">Australia/Broken_Hill (UTC+09:30)</option>
                    <option value="Australia/South">Australia/South (UTC+09:30)</option>
                    <option value="Australia/Darwin">Australia/Darwin (UTC+09:30)</option>
                    <option value="Etc/GMT-9">Etc/GMT-9 (UTC+09:00)</option>
                    <option value="Pacific/Palau">Pacific/Palau (UTC+09:00)</option>
                    <option value="Asia/Chita">Asia/Chita (UTC+09:00)</option>
                    <option value="Asia/Dili">Asia/Dili (UTC+09:00)</option>
                    <option value="Asia/Jayapura">Asia/Jayapura (UTC+09:00)</option>
                    <option value="Asia/Yakutsk">Asia/Yakutsk (UTC+09:00)</option>
                    <option value="Asia/Pyongyang">Asia/Pyongyang (UTC+09:00)</option>
                    <option value="ROK">ROK (UTC+09:00)</option>
                    <option value="Asia/Seoul">Asia/Seoul (UTC+09:00)</option>
                    <option value="Asia/Khandyga">Asia/Khandyga (UTC+09:00)</option>
                    <option value="Japan">Japan (UTC+09:00)</option>
                    <option value="Asia/Tokyo">Asia/Tokyo (UTC+09:00)</option>
                    <option value="Australia/Eucla">Australia/Eucla (UTC+08:45)</option>
                    <option value="Asia/Kuching">Asia/Kuching (UTC+08:00)</option>
                    <option value="Asia/Chungking">Asia/Chungking (UTC+08:00)</option>
                    <option value="Etc/GMT-8">Etc/GMT-8 (UTC+08:00)</option>
                    <option value="Australia/Perth">Australia/Perth (UTC+08:00)</option>
                    <option value="Asia/Macao">Asia/Macao (UTC+08:00)</option>
                    <option value="Asia/Macau">Asia/Macau (UTC+08:00)</option>
                    <option value="Asia/Choibalsan">Asia/Choibalsan (UTC+08:00)</option>
                    <option value="Asia/Shanghai">Asia/Shanghai (UTC+08:00)</option>
                    <option value="Antarctica/Casey">Antarctica/Casey (UTC+08:00)</option>
                    <option value="Asia/Ulan_Bator">Asia/Ulan_Bator (UTC+08:00)</option>
                    <option value="Asia/Chongqing">Asia/Chongqing (UTC+08:00)</option>
                    <option value="Asia/Ulaanbaatar">Asia/Ulaanbaatar (UTC+08:00)</option>
                    <option value="Asia/Taipei">Asia/Taipei (UTC+08:00)</option>
                    <option value="Asia/Manila">Asia/Manila (UTC+08:00)</option>
                    <option value="PRC">PRC (UTC+08:00)</option>
                    <option value="Asia/Ujung_Pandang">Asia/Ujung_Pandang (UTC+08:00)</option>
                    <option value="Asia/Harbin">Asia/Harbin (UTC+08:00)</option>
                    <option value="Singapore">Singapore (UTC+08:00)</option>
                    <option value="Asia/Brunei">Asia/Brunei (UTC+08:00)</option>
                    <option value="Australia/West">Australia/West (UTC+08:00)</option>
                    <option value="Asia/Hong_Kong">Asia/Hong_Kong (UTC+08:00)</option>
                    <option value="Asia/Makassar">Asia/Makassar (UTC+08:00)</option>
                    <option value="Hongkong">Hongkong (UTC+08:00)</option>
                    <option value="Asia/Kuala_Lumpur">Asia/Kuala_Lumpur (UTC+08:00)</option>
                    <option value="Asia/Irkutsk">Asia/Irkutsk (UTC+08:00)</option>
                    <option value="Asia/Singapore">Asia/Singapore (UTC+08:00)</option>
                    <option value="Asia/Pontianak">Asia/Pontianak (UTC+07:00)</option>
                    <option value="Etc/GMT-7">Etc/GMT-7 (UTC+07:00)</option>
                    <option value="Asia/Phnom_Penh">Asia/Phnom_Penh (UTC+07:00)</option>
                    <option value="Asia/Novosibirsk">Asia/Novosibirsk (UTC+07:00)</option>
                    <option value="Antarctica/Davis">Antarctica/Davis (UTC+07:00)</option>
                    <option value="Asia/Tomsk">Asia/Tomsk (UTC+07:00)</option>
                    <option value="Asia/Jakarta">Asia/Jakarta (UTC+07:00)</option>
                    <option value="Asia/Barnaul">Asia/Barnaul (UTC+07:00)</option>
                    <option value="Indian/Christmas">Indian/Christmas (UTC+07:00)</option>
                    <option value="Asia/Ho_Chi_Minh">Asia/Ho_Chi_Minh (UTC+07:00)</option>
                    <option value="Asia/Hovd">Asia/Hovd (UTC+07:00)</option>
                    <option value="Asia/Bangkok">Asia/Bangkok (UTC+07:00)</option>
                    <option value="Asia/Vientiane">Asia/Vientiane (UTC+07:00)</option>
                    <option value="Asia/Novokuznetsk">Asia/Novokuznetsk (UTC+07:00)</option>
                    <option value="Asia/Krasnoyarsk">Asia/Krasnoyarsk (UTC+07:00)</option>
                    <option value="Asia/Saigon">Asia/Saigon (UTC+07:00)</option>
                    <option value="Asia/Yangon">Asia/Yangon (UTC+06:30)</option>
                    <option value="Asia/Rangoon">Asia/Rangoon (UTC+06:30)</option>
                    <option value="Indian/Cocos">Indian/Cocos (UTC+06:30)</option>
                    <option value="Asia/Kashgar">Asia/Kashgar (UTC+06:00)</option>
                    <option value="Etc/GMT-6">Etc/GMT-6 (UTC+06:00)</option>
                    <option value="Asia/Almaty">Asia/Almaty (UTC+06:00)</option>
                    <option value="Asia/Dacca">Asia/Dacca (UTC+06:00)</option>
                    <option value="Asia/Omsk">Asia/Omsk (UTC+06:00)</option>
                    <option value="Asia/Dhaka">Asia/Dhaka (UTC+06:00)</option>
                    <option value="Indian/Chagos">Indian/Chagos (UTC+06:00)</option>
                    <option value="Asia/Qyzylorda">Asia/Qyzylorda (UTC+06:00)</option>
                    <option value="Asia/Bishkek">Asia/Bishkek (UTC+06:00)</option>
                    <option value="Antarctica/Vostok">Antarctica/Vostok (UTC+06:00)</option>
                    <option value="Asia/Urumqi">Asia/Urumqi (UTC+06:00)</option>
                    <option value="Asia/Thimbu">Asia/Thimbu (UTC+06:00)</option>
                    <option value="Asia/Thimphu">Asia/Thimphu (UTC+06:00)</option>
                    <option value="Asia/Kathmandu">Asia/Kathmandu (UTC+05:45)</option>
                    <option value="Asia/Katmandu">Asia/Katmandu (UTC+05:45)</option>
                    <option value="Asia/Kolkata">Asia/Kolkata (UTC+05:30)</option>
                    <option value="Asia/Colombo">Asia/Colombo (UTC+05:30)</option>
                    <option value="Asia/Calcutta">Asia/Calcutta (UTC+05:30)</option>
                    <option value="Asia/Aqtau">Asia/Aqtau (UTC+05:00)</option>
                    <option value="Etc/GMT-5">Etc/GMT-5 (UTC+05:00)</option>
                    <option value="Asia/Samarkand">Asia/Samarkand (UTC+05:00)</option>
                    <option value="Asia/Karachi">Asia/Karachi (UTC+05:00)</option>
                    <option value="Asia/Yekaterinburg">Asia/Yekaterinburg (UTC+05:00)</option>
                    <option value="Asia/Dushanbe">Asia/Dushanbe (UTC+05:00)</option>
                    <option value="Indian/Maldives">Indian/Maldives (UTC+05:00)</option>
                    <option value="Asia/Oral">Asia/Oral (UTC+05:00)</option>
                    <option value="Asia/Tashkent">Asia/Tashkent (UTC+05:00)</option>
                    <option value="Antarctica/Mawson">Antarctica/Mawson (UTC+05:00)</option>
                    <option value="Asia/Aqtobe">Asia/Aqtobe (UTC+05:00)</option>
                    <option value="Asia/Ashkhabad">Asia/Ashkhabad (UTC+05:00)</option>
                    <option value="Asia/Ashgabat">Asia/Ashgabat (UTC+05:00)</option>
                    <option value="Asia/Atyrau">Asia/Atyrau (UTC+05:00)</option>
                    <option value="Indian/Kerguelen">Indian/Kerguelen (UTC+05:00)</option>
                    <option value="Iran">Iran (UTC+04:30)</option>
                    <option value="Asia/Tehran">Asia/Tehran (UTC+04:30)</option>
                    <option value="Asia/Kabul">Asia/Kabul (UTC+04:30)</option>
                    <option value="Asia/Yerevan">Asia/Yerevan (UTC+04:00)</option>
                    <option value="Etc/GMT-4">Etc/GMT-4 (UTC+04:00)</option>
                    <option value="Asia/Dubai">Asia/Dubai (UTC+04:00)</option>
                    <option value="Indian/Reunion">Indian/Reunion (UTC+04:00)</option>
                    <option value="Indian/Mauritius">Indian/Mauritius (UTC+04:00)</option>
                    <option value="Europe/Saratov">Europe/Saratov (UTC+04:00)</option>
                    <option value="Europe/Samara">Europe/Samara (UTC+04:00)</option>
                    <option value="Indian/Mahe">Indian/Mahe (UTC+04:00)</option>
                    <option value="Asia/Baku">Asia/Baku (UTC+04:00)</option>
                    <option value="Asia/Muscat">Asia/Muscat (UTC+04:00)</option>
                    <option value="Europe/Volgograd">Europe/Volgograd (UTC+04:00)</option>
                    <option value="Europe/Astrakhan">Europe/Astrakhan (UTC+04:00)</option>
                    <option value="Asia/Tbilisi">Asia/Tbilisi (UTC+04:00)</option>
                    <option value="Europe/Ulyanovsk">Europe/Ulyanovsk (UTC+04:00)</option>
                    <option value="Asia/Aden">Asia/Aden (UTC+03:00)</option>
                    <option value="Africa/Nairobi">Africa/Nairobi (UTC+03:00)</option>
                    <option value="Europe/Istanbul">Europe/Istanbul (UTC+03:00)</option>
                    <option value="Etc/GMT-3">Etc/GMT-3 (UTC+03:00)</option>
                    <option value="Europe/Zaporozhye">Europe/Zaporozhye (UTC+03:00)</option>
                    <option value="Indian/Comoro">Indian/Comoro (UTC+03:00)</option>
                    <option value="Antarctica/Syowa">Antarctica/Syowa (UTC+03:00)</option>
                    <option value="Africa/Mogadishu">Africa/Mogadishu (UTC+03:00)</option>
                    <option value="Europe/Bucharest">Europe/Bucharest (UTC+03:00)</option>
                    <option value="Africa/Asmera">Africa/Asmera (UTC+03:00)</option>
                    <option value="Europe/Mariehamn">Europe/Mariehamn (UTC+03:00)</option>
                    <option value="Asia/Istanbul">Asia/Istanbul (UTC+03:00)</option>
                    <option value="Europe/Tiraspol">Europe/Tiraspol (UTC+03:00)</option>
                    <option value="Europe/Moscow">Europe/Moscow (UTC+03:00)</option>
                    <option value="Europe/Chisinau">Europe/Chisinau (UTC+03:00)</option>
                    <option value="Europe/Helsinki">Europe/Helsinki (UTC+03:00)</option>
                    <option value="Asia/Beirut">Asia/Beirut (UTC+03:00)</option>
                    <option value="Asia/Tel_Aviv">Asia/Tel_Aviv (UTC+03:00)</option>
                    <option value="Africa/Djibouti">Africa/Djibouti (UTC+03:00)</option>
                    <option value="Europe/Simferopol">Europe/Simferopol (UTC+03:00)</option>
                    <option value="Europe/Sofia">Europe/Sofia (UTC+03:00)</option>
                    <option value="Asia/Gaza">Asia/Gaza (UTC+03:00)</option>
                    <option value="Africa/Asmara">Africa/Asmara (UTC+03:00)</option>
                    <option value="Europe/Riga">Europe/Riga (UTC+03:00)</option>
                    <option value="Asia/Baghdad">Asia/Baghdad (UTC+03:00)</option>
                    <option value="Asia/Damascus">Asia/Damascus (UTC+03:00)</option>
                    <option value="Africa/Dar_es_Salaam">Africa/Dar_es_Salaam (UTC+03:00)</option>
                    <option value="Africa/Addis_Ababa">Africa/Addis_Ababa (UTC+03:00)</option>
                    <option value="Europe/Uzhgorod">Europe/Uzhgorod (UTC+03:00)</option>
                    <option value="Asia/Jerusalem">Asia/Jerusalem (UTC+03:00)</option>
                    <option value="Asia/Riyadh">Asia/Riyadh (UTC+03:00)</option>
                    <option value="Asia/Kuwait">Asia/Kuwait (UTC+03:00)</option>
                    <option value="Europe/Kirov">Europe/Kirov (UTC+03:00)</option>
                    <option value="Africa/Kampala">Africa/Kampala (UTC+03:00)</option>
                    <option value="Europe/Minsk">Europe/Minsk (UTC+03:00)</option>
                    <option value="Asia/Qatar">Asia/Qatar (UTC+03:00)</option>
                    <option value="Europe/Kiev">Europe/Kiev (UTC+03:00)</option>
                    <option value="Asia/Bahrain">Asia/Bahrain (UTC+03:00)</option>
                    <option value="Europe/Vilnius">Europe/Vilnius (UTC+03:00)</option>
                    <option value="Indian/Antananarivo">Indian/Antananarivo (UTC+03:00)</option>
                    <option value="Indian/Mayotte">Indian/Mayotte (UTC+03:00)</option>
                    <option value="Europe/Tallinn">Europe/Tallinn (UTC+03:00)</option>
                    <option value="Turkey">Turkey (UTC+03:00)</option>
                    <option value="Africa/Juba">Africa/Juba (UTC+03:00)</option>
                    <option value="Asia/Nicosia">Asia/Nicosia (UTC+03:00)</option>
                    <option value="Asia/Famagusta">Asia/Famagusta (UTC+03:00)</option>
                    <option value="W-SU">W-SU (UTC+03:00)</option>
                    <option value="EET">EET (UTC+03:00)</option>
                    <option value="Asia/Hebron">Asia/Hebron (UTC+03:00)</option>
                    <option value="Asia/Amman">Asia/Amman (UTC+03:00)</option>
                    <option value="Europe/Nicosia">Europe/Nicosia (UTC+03:00)</option>
                    <option value="Europe/Athens">Europe/Athens (UTC+03:00)</option>
                    <option value="Africa/Cairo">Africa/Cairo (UTC+02:00)</option>
                    <option value="Africa/Mbabane">Africa/Mbabane (UTC+02:00)</option>
                    <option value="Europe/Brussels">Europe/Brussels (UTC+02:00)</option>
                    <option value="Europe/Warsaw">Europe/Warsaw (UTC+02:00)</option>
                    <option value="CET">CET (UTC+02:00)</option>
                    <option value="Europe/Luxembourg">Europe/Luxembourg (UTC+02:00)</option>
                    <option value="Etc/GMT-2">Etc/GMT-2 (UTC+02:00)</option>
                    <option value="Libya">Libya (UTC+02:00)</option>
                    <option value="Africa/Kigali">Africa/Kigali (UTC+02:00)</option>
                    <option value="Africa/Tripoli">Africa/Tripoli (UTC+02:00)</option>
                    <option value="Europe/Kaliningrad">Europe/Kaliningrad (UTC+02:00)</option>
                    <option value="Africa/Windhoek">Africa/Windhoek (UTC+02:00)</option>
                    <option value="Europe/Malta">Europe/Malta (UTC+02:00)</option>
                    <option value="Europe/Busingen">Europe/Busingen (UTC+02:00)</option>
                    <option value="Europe/Skopje">Europe/Skopje (UTC+02:00)</option>
                    <option value="Europe/Sarajevo">Europe/Sarajevo (UTC+02:00)</option>
                    <option value="Europe/Rome">Europe/Rome (UTC+02:00)</option>
                    <option value="Europe/Zurich">Europe/Zurich (UTC+02:00)</option>
                    <option value="Europe/Gibraltar">Europe/Gibraltar (UTC+02:00)</option>
                    <option value="Africa/Lubumbashi">Africa/Lubumbashi (UTC+02:00)</option>
                    <option value="Europe/Vaduz">Europe/Vaduz (UTC+02:00)</option>
                    <option value="Europe/Ljubljana">Europe/Ljubljana (UTC+02:00)</option>
                    <option value="Europe/Berlin">Europe/Berlin (UTC+02:00)</option>
                    <option value="Europe/Stockholm">Europe/Stockholm (UTC+02:00)</option>
                    <option value="Europe/Budapest">Europe/Budapest (UTC+02:00)</option>
                    <option value="Europe/Zagreb">Europe/Zagreb (UTC+02:00)</option>
                    <option value="Europe/Paris">Europe/Paris (UTC+02:00)</option>
                    <option value="Africa/Ceuta">Africa/Ceuta (UTC+02:00)</option>
                    <option value="Europe/Prague">Europe/Prague (UTC+02:00)</option>
                    <option value="Antarctica/Troll">Antarctica/Troll (UTC+02:00)</option>
                    <option value="Africa/Gaborone">Africa/Gaborone (UTC+02:00)</option>
                    <option value="Europe/Copenhagen">Europe/Copenhagen (UTC+02:00)</option>
                    <option value="Europe/Vienna">Europe/Vienna (UTC+02:00)</option>
                    <option value="Europe/Tirane">Europe/Tirane (UTC+02:00)</option>
                    <option value="MET">MET (UTC+02:00)</option>
                    <option value="Europe/Amsterdam">Europe/Amsterdam (UTC+02:00)</option>
                    <option value="Africa/Maputo">Africa/Maputo (UTC+02:00)</option>
                    <option value="Europe/San_Marino">Europe/San_Marino (UTC+02:00)</option>
                    <option value="Poland">Poland (UTC+02:00)</option>
                    <option value="Europe/Andorra">Europe/Andorra (UTC+02:00)</option>
                    <option value="Europe/Oslo">Europe/Oslo (UTC+02:00)</option>
                    <option value="Europe/Podgorica">Europe/Podgorica (UTC+02:00)</option>
                    <option value="Africa/Bujumbura">Africa/Bujumbura (UTC+02:00)</option>
                    <option value="Atlantic/Jan_Mayen">Atlantic/Jan_Mayen (UTC+02:00)</option>
                    <option value="Africa/Maseru">Africa/Maseru (UTC+02:00)</option>
                    <option value="Europe/Madrid">Europe/Madrid (UTC+02:00)</option>
                    <option value="Africa/Blantyre">Africa/Blantyre (UTC+02:00)</option>
                    <option value="Africa/Lusaka">Africa/Lusaka (UTC+02:00)</option>
                    <option value="Africa/Harare">Africa/Harare (UTC+02:00)</option>
                    <option value="Africa/Khartoum">Africa/Khartoum (UTC+02:00)</option>
                    <option value="Africa/Johannesburg">Africa/Johannesburg (UTC+02:00)</option>
                    <option value="Europe/Belgrade">Europe/Belgrade (UTC+02:00)</option>
                    <option value="Europe/Bratislava">Europe/Bratislava (UTC+02:00)</option>
                    <option value="Arctic/Longyearbyen">Arctic/Longyearbyen (UTC+02:00)</option>
                    <option value="Egypt">Egypt (UTC+02:00)</option>
                    <option value="Europe/Vatican">Europe/Vatican (UTC+02:00)</option>
                    <option value="Europe/Monaco">Europe/Monaco (UTC+02:00)</option>
                    <option value="Europe/London">Europe/London (UTC+01:00)</option>
                    <option value="Etc/GMT-1">Etc/GMT-1 (UTC+01:00)</option>
                    <option value="Europe/Jersey">Europe/Jersey (UTC+01:00)</option>
                    <option value="Europe/Guernsey">Europe/Guernsey (UTC+01:00)</option>
                    <option value="Europe/Isle_of_Man">Europe/Isle_of_Man (UTC+01:00)</option>
                    <option value="Africa/Tunis">Africa/Tunis (UTC+01:00)</option>
                    <option value="Africa/Malabo">Africa/Malabo (UTC+01:00)</option>
                    <option value="GB-Eire">GB-Eire (UTC+01:00)</option>
                    <option value="Africa/Lagos">Africa/Lagos (UTC+01:00)</option>
                    <option value="Africa/Algiers">Africa/Algiers (UTC+01:00)</option>
                    <option value="GB">GB (UTC+01:00)</option>
                    <option value="Portugal">Portugal (UTC+01:00)</option>
                    <option value="Africa/Sao_Tome">Africa/Sao_Tome (UTC+01:00)</option>
                    <option value="Africa/Ndjamena">Africa/Ndjamena (UTC+01:00)</option>
                    <option value="Atlantic/Faeroe">Atlantic/Faeroe (UTC+01:00)</option>
                    <option value="Eire">Eire (UTC+01:00)</option>
                    <option value="Atlantic/Faroe">Atlantic/Faroe (UTC+01:00)</option>
                    <option value="Europe/Dublin">Europe/Dublin (UTC+01:00)</option>
                    <option value="Africa/Libreville">Africa/Libreville (UTC+01:00)</option>
                    <option value="Africa/El_Aaiun">Africa/El_Aaiun (UTC+01:00)</option>
                    <option value="Africa/Douala">Africa/Douala (UTC+01:00)</option>
                    <option value="Africa/Brazzaville">Africa/Brazzaville (UTC+01:00)</option>
                    <option value="Africa/Porto-Novo">Africa/Porto-Novo (UTC+01:00)</option>
                    <option value="Atlantic/Madeira">Atlantic/Madeira (UTC+01:00)</option>
                    <option value="Europe/Lisbon">Europe/Lisbon (UTC+01:00)</option>
                    <option value="Atlantic/Canary">Atlantic/Canary (UTC+01:00)</option>
                    <option value="Africa/Casablanca">Africa/Casablanca (UTC+01:00)</option>
                    <option value="Europe/Belfast">Europe/Belfast (UTC+01:00)</option>
                    <option value="Africa/Luanda">Africa/Luanda (UTC+01:00)</option>
                    <option value="Africa/Kinshasa">Africa/Kinshasa (UTC+01:00)</option>
                    <option value="Africa/Bangui">Africa/Bangui (UTC+01:00)</option>
                    <option value="WET">WET (UTC+01:00)</option>
                    <option value="Africa/Niamey">Africa/Niamey (UTC+01:00)</option>
                    <option value="GMT">GMT (UTC+00:00)</option>
                    <option value="Etc/GMT-0">Etc/GMT-0 (UTC+00:00)</option>
                    <option value="Atlantic/St_Helena">Atlantic/St_Helena (UTC+00:00)</option>
                    <option value="Etc/GMT+0">Etc/GMT+0 (UTC+00:00)</option>
                    <option value="Africa/Banjul">Africa/Banjul (UTC+00:00)</option>
                    <option value="Etc/GMT">Etc/GMT (UTC+00:00)</option>
                    <option value="Africa/Freetown">Africa/Freetown (UTC+00:00)</option>
                    <option value="Africa/Bamako">Africa/Bamako (UTC+00:00)</option>
                    <option value="Africa/Conakry">Africa/Conakry (UTC+00:00)</option>
                    <option value="Universal">Universal (UTC+00:00)</option>
                    <option value="Africa/Nouakchott">Africa/Nouakchott (UTC+00:00)</option>
                    <option value="UTC">UTC (UTC+00:00)</option>
                    <option value="Etc/Universal">Etc/Universal (UTC+00:00)</option>
                    <option value="Atlantic/Azores">Atlantic/Azores (UTC+00:00)</option>
                    <option value="Africa/Abidjan">Africa/Abidjan (UTC+00:00)</option>
                    <option value="Africa/Accra">Africa/Accra (UTC+00:00)</option>
                    <option value="Etc/UCT">Etc/UCT (UTC+00:00)</option>
                    <option value="GMT0">GMT0 (UTC+00:00)</option>
                    <option value="Zulu">Zulu (UTC+00:00)</option>
                    <option value="Africa/Ouagadougou">Africa/Ouagadougou (UTC+00:00)</option>
                    <option value="Atlantic/Reykjavik">Atlantic/Reykjavik (UTC+00:00)</option>
                    <option value="Etc/Zulu">Etc/Zulu (UTC+00:00)</option>
                    <option value="Iceland">Iceland (UTC+00:00)</option>
                    <option value="Africa/Lome">Africa/Lome (UTC+00:00)</option>
                    <option value="Greenwich">Greenwich (UTC+00:00)</option>
                    <option value="Etc/GMT0">Etc/GMT0 (UTC+00:00)</option>
                    <option value="America/Danmarkshavn">America/Danmarkshavn (UTC+00:00)</option>
                    <option value="Africa/Dakar">Africa/Dakar (UTC+00:00)</option>
                    <option value="America/Scoresbysund">America/Scoresbysund (UTC+00:00)</option>
                    <option value="Africa/Bissau">Africa/Bissau (UTC+00:00)</option>
                    <option value="Etc/Greenwich">Etc/Greenwich (UTC+00:00)</option>
                    <option value="Africa/Timbuktu">Africa/Timbuktu (UTC+00:00)</option>
                    <option value="UCT">UCT (UTC+00:00)</option>
                    <option value="Africa/Monrovia">Africa/Monrovia (UTC+00:00)</option>
                    <option value="Etc/UTC">Etc/UTC (UTC+00:00)</option>
                  </AvField>
                </AvGroup>
                <AvGroup>
                  <Label id="statusLabel" for="status">
                    <Translate contentKey="dealorGatewayApp.tenant.status">Status</Translate>
                  </Label>
                  <AvField id="tenant-status" type="number" name="status" />
                </AvGroup>
                <AvGroup>
                  <Label id="keepaliveLabel" for="keepalive">
                    <Translate contentKey="dealorGatewayApp.tenant.keepalive">Keepalive</Translate>
                  </Label>
                  <AvField id="tenant-keepalive" type="number" name="keepalive" />
                </AvGroup>
                <AvGroup>
                  <Label id="websiteLabel" for="website">
                    <Translate contentKey="dealorGatewayApp.tenant.website">Website</Translate>
                  </Label>
                  <AvField id="tenant-website" type="text" name="website" />
                </AvGroup>
                <Button tag={Link} id="cancel-save" to="/entity/tenant" replace color="info">
                  <FontAwesomeIcon icon="arrow-left" />
                  &nbsp;
                  <span className="d-none d-md-inline">
                    <Translate contentKey="entity.action.back">Back</Translate>
                  </span>
                </Button>
                &nbsp;
                <Button color="primary" id="save-entity" type="submit" disabled={updating}>
                  <FontAwesomeIcon icon="save" />
                  &nbsp;
                  <Translate contentKey="entity.action.save">Save</Translate>
                </Button>
              </AvForm>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  tenantEntity: storeState.tenant.entity,
  loading: storeState.tenant.loading,
  updating: storeState.tenant.updating,
  updateSuccess: storeState.tenant.updateSuccess
});

const mapDispatchToProps = {
  getEntity,
  updateEntity,
  createEntity,
  reset
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TenantUpdate);
